<template>
    <v-card
        elevation="0"
        class="pb-6"
        style="border-top: solid 2px"
        :loading="ChartComerciales.isLoading"
    >
        <v-card-title
            class="d-flex justify-center"
            style="background-color: #e5e5e5"
        >
            <v-flex
                class="overline text-center"
                style="font-size: 1rem !important; color: black; border"
            >
                Comerciales
            </v-flex>
            <div class="ml-auto">
                <v-btn
                    class="mt-n2"
                    color="red lighten-2"
                    dark
                    icon
                    large
                    @click="openInfo"
                >
                    <v-icon> mdi-map-legend </v-icon>
                </v-btn>
            </div>
        </v-card-title>
        <v-divider class="test"></v-divider>
        <BarChart
            v-if="!ChartComerciales.isLoading"
            :chart-data="ChartComerciales.comercialesStats"
            :options="optionsBarChart"
        ></BarChart>
        <v-container v-else fill-height fluid class="text-center">
            <v-progress-circular
                class="mx-auto"
                :size="50"
                :width="5"
                indeterminate
                color="primary"
            ></v-progress-circular>
        </v-container>
        <Legend :items="legend" />
    </v-card>
</template>

<script>
import { mapState } from 'vuex';
import BarChart from './BarChart.js';
import Legend from '@/components/GerenciaTeletrabajo/ComercialesTable/Legend.vue';

export default {
    name: 'StatsComerciales',
    components: {
        BarChart,
        Legend,
    },
    data: () => ({
        legend: [
            {
                title: 'Atenciones',
                icon: 'mdi-account-plus',
                text: 'Número de atenciones realizadas',
            },
            {
                title: 'Ofertas',
                icon: 'mdi-flag-triangle',
                text: 'Número de ofertas presupuestadas',
            },
            {
                title: 'Atenciones vendidas',
                icon: 'mdi-flag-triangle',
                text: 'Número de ofertas vendidas y gestiones realizadas',
            },
            {
                title: 'Ventas',
                icon: 'mdi-tag',
                text: 'Número de paquetes vendidos',
            },
            {
                title: 'Ventas valor',
                icon: 'mdi-flag',
                text: 'Número total de paquetes Fijos y Pospago vendidos',
            },
        ],
        dialog: false,
        optionsBarChart: {
            scales: {
                yAxes: [
                    {
                        stacked: true,
                    },
                ],
                xAxes: [
                    {
                        stacked: true,
                    },
                ],
            },
            legend: {
                display: true,
                position: 'top',
                align: 'center',
                labels: {
                    padding: 10,
                },
            },
            responsive: true,
            maintainAspectRatio: false,
        },
    }),
    methods: {
        openInfo() {
            this.$store.commit('util/isOpenLegendDialog', true);
        },
    },
    computed: {
        ...mapState('statistics', {
            ChartComerciales: (state) => state.ChartComerciales,
        }),
    },
};
</script>

<style>
</style>